<h3 matDialogTitle>{{ 'GNR_EXTRACTION_OPT_IN_TITLE' | translate }}</h3>
<button class="close-btn" mat-icon-button matDialogClose>
  <mat-icon>close</mat-icon>
</button>

<mat-dialog-content>
  @if (fileName) {
    <p class="file-name">
      <mat-icon>description</mat-icon>
      <span>{{ fileName }}</span>
    </p>
  }

  <p class="opt-in-message">
    {{ 'GNR_EXTRACTION_OPT_IN_MESSAGE' | translate }}
  </p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-button (click)="decline()">
    {{ 'GNR_EXTRACTION_OPT_IN_DECLINE' | translate }}
  </button>
  <button mat-button class="qt-dialog-primary-button" (click)="accept()">
    {{ 'GNR_EXTRACTION_OPT_IN_ACCEPT' | translate }}
  </button>
</mat-dialog-actions>
